export const DELETE_CONTACT_QUERY_KEY = ['delete', 'contact'] as const;
